<template>
    <small>
        <validation-observer v-slot="{handleSubmit}">
            <form
                class="accesso-album my-1"
                @submit.prevent="onSubmit"
                method="post"
            >
                <div class="form-group mb-0">
                    <label
                        for="email"
                        class="text-blurikorda text-uppercase font-titoli-rikorda"
                    >{{ $t("Indirizzo email") }}</label>

                    <validation-provider
                        rules="required|validEmail"
                        mode="passive"
                        :debounce="5"
                        v-slot="{ errors, touched, valid, invalid, pending, validate }"
                        tag="div"
                        class="custom-control mt-1 mr-0 pl-0"
                    >
                        <b-form-input
                            type="email"
                            name="email"
                            id="email"
                            class="text-center w-100 rounded-pill rilievo-ombra-interna"
                            :placeholder="$t('Inserisci email')"
                            v-model="email"
                            :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                            @focus="resetValidateEmailError"
                            @change="validate()"
                        >
                        </b-form-input>
                        <span class="text-danger">{{errors[0]}}</span>
                    </validation-provider>
                </div>

                <div class="mt-3">
                    <div class="form-check pl-0">
                        <validation-provider
                            :rules="{required: {allowFalse: false}}"
                            v-slot="{errors}"
                        >
                            <b-form-checkbox
                                id="checkbox-informativa"
                                v-model="checkboxInformativa"
                                name="checkbox-informativa"
                            >
                                {{$t("Ai sensi del Reg. (UE)2016/679, prendo atto dell'")}}
                                <a
                                    href="#"
                                    @click.prevent="onReadFullPage('INFORMATIVA')"
                                >
                                    {{$t("informativa relativa al trattamento dei dati personali")}}
                                </a>
                                {{$t(' ed autorizzo il trattamento conseguente alla fruizione del servizio (accesso alla PhotoGallery, ordine di stampa, pagamento, ecc.)')}}
                            </b-form-checkbox>
                            <span class="text-danger">{{errors[0]}}</span>
                        </validation-provider>

                        <validation-provider
                            :rules="{required: {allowFalse: false}}"
                            v-slot="{errors}"
                        >
                            <b-form-checkbox
                                id="checkbox-termini-condizioni"
                                v-model="checkboxTerminiCondizioni"
                                name="checkbox-termini-condizioni"
                            >
                                {{$t("Accetto i ")}}
                                <a
                                    href="#"
                                    @click.prevent="onReadFullPage('TERMINICONDIZIONIFOTOGRAFOUTENTI')"
                                >
                                    {{$t("termini e condizioni del servizio")}}
                                </a>
                                {{$t(" per l'utilizzo della piattaforma Rikorda Eventi")}}
                            </b-form-checkbox>
                            <span class="text-danger">{{errors[0]}}</span>
                        </validation-provider>

                        <b-form-checkbox
                            id="checkbox-marketing"
                            v-model="checkboxMarketing"
                            name="checkbox-marketing"
                        >
                            {{$t('Acconsento, inoltre, al trattamento dei soli dati personali di contatto per finalità di marketing diretto per promozione e vendita di prodotti e servizi del fotografo e per la rilevazione del grado di soddisfazione.')}}
                        </b-form-checkbox>
                    </div>
                    <span
                        class="mt-1 text-danger"
                        v-show="validateEmailError"
                    >
                        {{ $t(validateEmailError) }}
                    </span>
                </div>

                <div class="mb-0 text-center">
                    <button
                        type="submit"
                        class="btn btn-dark btn-rikorda1 mt-3 btn-icon-right"
                        @click.prevent="handleSubmit(onSubmit)"
                    >
                        {{ $t("Apri la galleria") }}
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </button>
                </div>
            </form>

            <GDPRViewer
                ref="gdprViewer"
                :gdpr="gdprToView"
                :shop="shop"
                :title="gdprTitleToView"
                :hasCustomGdpr="hasCustomGdpr"
                :isClientTerms="isClientTerms"
            >
                <slot></slot>
            </GDPRViewer>

        </validation-observer>
    </small>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import GDPRViewer from "./GDPRViewer";

extend("required", required);

export default {
    name: "MailValidationForm",

    props: ["eventId"],

    components: { GDPRViewer, ValidationObserver, ValidationProvider },

    data() {
        return {
            email: "",
            validateEmailError: false,
            checkboxInformativa: false,
            checkboxTerminiCondizioni: false,
            checkboxMarketing: false,
            gdpr: {
                default: null,
                custom: null
            },
            gdprToView: null,
            gdprTitleToView: null, // FIXME: serve o si può rimuovere ???
            shop: {},
            isClientTerms: false
        };
    },

    mounted() {
        var shopData = this.$store.getters.shopData;
        if (shopData.docs) {
            this.gdpr = shopData.docs;
        }
        if (shopData.shop) {
            this.shop = shopData.shop;
        }
    },

    methods: {
        resetValidateEmailError() {
            this.validateEmailError = false;
        },

        onSubmit() {
            console.log("ONSUBMIT");
            this.$store
                .dispatch("VALIDATE_MAIL", {
                    eventId: this.eventId,
                    email: this.email,
                    acceptTerms: this.checkboxMarketing
                })
                .then((result) => {
                    console.debug("VALIDATE_MAIL", result);
                    this.$router.push({
                        name: "gallery-dashboard",
                        params: {
                            galleryUrl: this.$route.params.galleryUrl
                        }
                    });
                })
                .catch((error) => {
                    console.error("VALIDATE_MAIL", error);
                    this.error = true;
                    if (error === "Accesso negato") {
                        this.validateEmailError = this.$t("Accesso negato");
                    } else {
                        this.validateEmailError = this.$t(
                            "Errore durante la validazione dell'email. Riprova."
                        );
                    }
                });
        },

        onReadFullPage(docType) {
            switch (docType) {
                case "INFORMATIVA":
                    this.gdprTitleToView = "Informativa privacy del servizio";
                    this.gdprToView = this.getFilledDocument("INFORMATIVA");
                    this.isClientTerms = false;
                    break;
                case "TERMINICONDIZIONIFOTOGRAFOUTENTI":
                    this.gdprTitleToView =
                        "Termini e Condizioni del servizio Fotografo - Utenti finali";
                    this.gdprToView = this.getFilledDocument(
                        "TERMINICONDIZIONIFOTOGRAFOUTENTI"
                    );
                    this.isClientTerms = true;
                    break;
            }
            this.$bvModal.show(this.$refs.gdprViewer.id);
        },

        getFilledDocument(docType) {
            var doc;
            switch (docType) {
                case "INFORMATIVA":
                    doc = this.gdpr.default.Informativa;
                    break;
                case "TERMINICONDIZIONIFOTOGRAFOUTENTI":
                    doc = this.gdpr.default.TerminiCondizioniFotografoUtenti;
                    break;
                default:
                    doc = "";
            }

            Array.from(Object.keys(this.shop)).forEach((el) => {
                if (el === "dpo") {
                    doc = doc.replaceAll(
                        "[[__DPO__]]",
                        this.shop[el]
                            ? this.shop[el]
                            : "non è stato individuato"
                    );
                }
                doc = doc.replaceAll(
                    "[[__" + el.toUpperCase() + "__]]",
                    this.shop[el]
                );
            });

            doc = doc.replaceAll(
                "[[__DATAACCETTAZIONE__]]",
                new Date().toLocaleDateString("it-IT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                })
            );

            return doc;
        }
    },

    computed: {
        hasCustomGdpr() {
            return (
                this.gdpr.custom &&
                Object.prototype.hasOwnProperty.call(
                    this.gdpr.custom,
                    "fkUtente"
                )
            );
        }
    }
};
extend("required", {
    ...required,
    message: "Questo campo è obbligatorio"
});
</script>

<style scoped>
@media (orientation: portrait) and (max-width: 767px) {
    .form-check {
        overflow: auto;
        max-height: 8.75rem;
    }
}
@media (orientation: landscape) and (max-width: 767px) {
    .form-check {
        overflow: auto;
        max-height: 7rem;
    }
}
</style>
